




















import { Component, Mixins, Prop } from 'vue-property-decorator';

import bracketsMixin from '../mixins/brackets-mixin';

@Component({})
export default class extends Mixins(bracketsMixin) {
	// --- props

	@Prop({ default: false, type: Boolean }) public readonly showLength!: boolean;

	// --- methods

	closedBracketsGenerator(data: any): string {
		return this.bracketsFormatter(Array.isArray(data) ? '[...]' : '{...}');
	}

	lengthGenerator(data: any): string {
		return ` // ${Array.isArray(data) ? `${data.length} items` : `${Object.keys(data).length} keys`}`;
	}
}
